module.exports = __webpack_public_path__ + "img/Add-files-pana.74651523.png";